import EBarEnactmentsCTA from './EBarEnactmentsCTA';

export default EBarEnactmentsCTA;
